// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3jY7k","unreadBadge":"styles_unreadBadge__1mozk","modalContent":"styles_modalContent__2Bnnj","modal":"styles_modal__3ScUb"};